import { pharmacyClient } from "@/connect";

export const getShiftHistory = async (page: number, pageSize: number) => {
  return await pharmacyClient.listShifts({
    page: Math.max(1, Number(page) || 1),
    pageSize: pageSize
  });
};